






































































import { Component, Vue, Watch } from 'vue-property-decorator'

import ApiIncoming from '@finx/web-repository/src/apis/Incoming/Incoming'
import Env from '@finx/web-repository/src/services/Env'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Apis, Factories } from '@finx/web-repository'
import NavBarStore from '@finx/web-repository/src/stores/NavBar'
import StatusStore from '@finx/web-repository/src/stores/Status'
import TheFooterStore from '@finx/web-repository/src/stores/TheFooter'
import AssinaturasStore from '@/store/Assinaturas'
import _navBar from '@/components/NavBar/_'
// teste poc/acCamargo
import { signalRRemuneracaoBackofficeService } from '@/services/signalR-remuneracao-backoffice.service'

import _ from 'lodash'

// @ts-ignore
import Variables from '@/styles/variables.scss'

// EventBus
import EventBus from '@/plugins/EventBus'
import { interceptorConfig } from '@finx/web-repository/src/apis/interceptor-config'
import { backofficeRoute } from '@/utils/common'
import { Loading } from './types/_'

@Component
export default class CoreView extends Vue {
  timer: number
  compile: boolean = false
  isTokenExpired: boolean = true
  user: any = {}
  fab: boolean = false
  snack: any = {
    show: false,
    text: '',
    icon: '',
    color: '',
    timeout: 4500,
    multiLine: false,
    dismissible: false,
    acceptHTML: false,
  }

  loading: Loading = {
    status: false,
    text: '',
  }

  get snackbar() {
    return this.snack
  }

  set snackbar(value: any) {
    this.snack = value
  }

  get loadingRequest() {
    return this.loading
  }

  set loadingRequest(value: Loading) {
    this.loading = value
  }

  setGlobalLoadingRequest(status: boolean, text: string) {
    this.loadingRequest.status = status
    this.loadingRequest.text = text
  }

  clearGlobalLoadingRequest() {
    this.setGlobalLoadingRequest(false, '')
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  onScroll(e) {
    if (typeof window === 'undefined') return
    const top = window.pageYOffset || e.target.scrollTop || 0
    this.fab = top > 400
  }

  backToTop() {
    this.$vuetify.goTo(0)
  }

  get assinatura() {
    return AssinaturasStore.getters.ASSINATURA
  }

  set assinatura(newValue) {
    AssinaturasStore.commit('ASSINATURA', newValue)
  }

  get hasAssinatura(): Boolean {
    return this.assinatura && Object.keys(this.assinatura).length > 0
  }

  get showNavBar() {
    return NavBarStore.getters.SHOW
  }

  get showStatus() {
    return StatusStore.getters.SHOW
  }

  get showTheFooter() {
    return TheFooterStore.getters.SHOW
  }

  get statusIsAtivo() {
    return StatusStore.getters.ATIVO
  }

  get backofficeArea() {
    return backofficeRoute()
  }

  get env() {
    const windowInfo = (window as any)
    return windowInfo.ENV
  }

  setGlobalSnackbar(snack) {
    this.snackbar = snack
  }

  resetLogoutTimer() {
    clearTimeout(this.timer)

    this.timer = setTimeout(this.logout, 5400000)
  }

  logout() {
    if (this.backofficeArea !== 'power-bi') {
      Auth.logout()
    }
  }

  enableAutoLogout() {
    window.addEventListener('load', this.resetLogoutTimer)
    window.addEventListener('touchstart', this.resetLogoutTimer)
    window.addEventListener('keydown', this.resetLogoutTimer)
    window.addEventListener('keyup', this.resetLogoutTimer)
    window.addEventListener('focus', this.resetLogoutTimer)
    window.addEventListener('blur', this.resetLogoutTimer)
    window.addEventListener('click', this.resetLogoutTimer)
    window.addEventListener('visibilitychange', this.resetLogoutTimer)
  }

  async mounted() {
    Auth.initialize()
    await this.startApp()

    if (this.user && (this.env === 'production')) {
      this.enableAutoLogout()
    }

    // eslint-disable-next-line
    console.log(`%c
███████╗██╗███╗   ██╗██╗  ██╗
██╔════╝██║████╗  ██║╚██╗██╔╝
█████╗  ██║██╔██╗ ██║ ╚███╔╝
██╔══╝  ██║██║╚██╗██║ ██╔██╗
██║     ██║██║ ╚████║██╔╝ ██╗
╚═╝     ╚═╝╚═╝  ╚═══╝╚═╝  ╚═╝

Integração e Transparência. Conectando os players da Saúde!

    `, 'color: #00AEEF')

    // Disable console if is production
    if (this.env === 'production') {
      this.disableConsole()
    }
  }

  async startApp() {
    await this.getUser()
    await this.checkAuthentication()
    EventBus.$on('setSnackbar', value => this.setGlobalSnackbar(value))
    EventBus.$on('setLoadingRequest', value => this.setGlobalLoadingRequest(value.status, value.text))
    EventBus.$on('clearLoadingRequest', value => this.clearGlobalLoadingRequest())

    // Configure globally additional errors for web repository interceptor
    interceptorConfig.addAdditionalStatusCodeError(502, 503)

    // Configure globally additional interceptors by code error for web repository interceptor
    interceptorConfig.addInterceptorStatusCodeError(503, ((
      url: string,
      status: number,
      data: any,
      headers: any,
      response: any,
      nextFn: () => {},
    ) => {
      // When is 503 and has a body with attribute { "tempoPrevistoDeManutencao": 30 // Em minutos }
      // Need block alert and redirect to 503. So can't call nextFn
      try {
        if (response && response.tempoPrevistoDeManutencao) {
          if (this.$route.path !== '/503') {
            this.$router.push(
              `/503?retryAfter=${response.tempoPrevistoDeManutencao}`,
            )
          }
        } else {
          nextFn()

          if (this.$route.path !== '/503') {
            this.$router.push('/503')
          }
        }
      // eslint-disable-next-line no-empty
      } catch (err) { }
    }) as any)

    // // teste poc/acCamargo
    // const userId = this.$user.profile.sub
    // signalRRemuneracaoBackofficeService.openConnection(userId)
  }

  async changeRoute(to, from) {
    await this.redirect()
    // await this.getAssinatura()
    await this.compileMenu()
    await this.compileView()
    await this.setUserId()
    await this.trackErrors(to, from)
  }

  async getUser() {
    if (this.$user && this.$user.profile) {
      localStorage.setItem('lastUser', this.$user.profile.email)
    }
  }

  async redirect() {
    const { redirectIfLogged, isPublic } = (this.$router as any).history.current.meta
    if (this.isTokenExpired) {
      if (!isPublic) {
        await Auth.login('/')
      }
    } else if (redirectIfLogged && this.user) {
      return new Promise((resolve, reject) => {
        this.$router.push(redirectIfLogged, resolve, reject)
      })
    }

    return false
  }

  async checkAuthentication() {
    const now = Math.floor(Date.now() / 1000)
    if (this.$user) this.isTokenExpired = Number(this.$user.expiresAt) < now
  }

  async compileMenu() {
    let { showMenu } = (this.$router as any).history.current.meta
    if (typeof showMenu === 'undefined') showMenu = true

    NavBarStore.commit('SHOW', showMenu)

    const roles: string[] = ['agendamento', 'pilotoAgendamento', 'remuneracaoMedicaPleno', 'remuneracaoMedicaHospital', 'extratoPagamento']
    let rolePerfil: string = ''

    if (this.$user !== null && this.$user.profile && this.$user.profile.roles) {
      if (Array.isArray(this.$user.profile.roles)) {
        this.$user.profile.roles.map((r) => {
          if (roles.some(c => c === r)) {
            rolePerfil = r
          }
          return r
        })
      }
    }

    const rotas: any[] = []

    _navBar.NavBar.map((c) => {
      if (this.$user && (c.isAuthorized || (this.$user.profile.pageAuthorized && this.$user.profile.pageAuthorized.includes(c.keyAuthorized)))) {
        rotas.push(c)
      }
      return c
    })

    if (this.$user && this.$user.profile && this.$user.profile.pageAuthorized && this.$user.profile.pageAuthorized.includes('home')) {
      rotas.length = 0
      _navBar.NavBarNew.map((c) => {
        if (this.$user && (c.isAuthorized || (this.$user.profile.pageAuthorized && this.$user.profile.pageAuthorized.includes(c.keyAuthorized)))) {
          rotas.push(c)
        }
        return c
      })
    }

    NavBarStore.commit('ROTAS', rotas)

    // this.loadRotas(rolePerfil)
    TheFooterStore.commit('SHOW', showMenu)
    this.compileStatus(showMenu)
  }

  loadRotas(role: string) {
    switch (role) {
      case 'agendamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarMenuAgendamentoMedico)
        break

      case 'pilotoAgendamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarAgendamentoMedico)
        break

      case 'remuneracaoMedicaPleno':
        NavBarStore.commit('ROTAS', _navBar.NavBarRemuneracaoMedicaPleno)
        break

      case 'remuneracaoMedicaHospital':
        NavBarStore.commit('ROTAS', _navBar.NavBarRemuneracaoMedicaHospital)
        break

      case 'extratoPagamento':
        NavBarStore.commit('ROTAS', _navBar.NavBarExtratoPagamento)
        break

      default:
        NavBarStore.commit('ROTAS', _navBar.NavBar)
        break
    }
  }

  async compileStatus(showMenu) {
    const status = StatusStore.getters.SHOW
    StatusStore.commit('ATIVO', false)

    if (status && showMenu) {
      StatusStore.commit('ATIVO', true)
    }
  }

  async compileView() {
    this.compile = true
  }

  async setUserId() {
    if (this.user && this.user.profile) {
      (Vue as any).$ga.set('userId', this.user.profile.email)
    }
  }

  async sendErrorAlert(to, from) {
    let userEmail = 'Não logado'

    if (this.user && this.user.profile) userEmail = this.user.profile.email

    const message = {
      title: 'Erro 404',
      text: `
      Erro na 404 na URL: ${to}
      Tela anterior: ${from}
      Usuário: ${userEmail}`,
      themeColor: Variables.clError,
    }

    ApiIncoming.Alert.sendAlert(message)
  }

  async setNavBarRoles(value) {
    return new Promise((resolve: any, reject: any) => {
      const roles = ['PLANO_CALCULADORA']

      NavBarStore.commit('ROLES', roles)

      resolve()
    })
  }

  async trackErrors(to, from) {
    if (to && from) {
      const pathTo = to.path
      let pathFrom = 'Acesso direto'

      if (from.name) pathFrom = from.path

      switch (to.name) {
        case 'not-found':
          this.sendErrorAlert(pathTo, pathFrom)
          break

        default:
          break
      }
    }
  }

  async getAssinatura(force?) {
    return new Promise(async (resolve: any, reject: any) => {
      if (!this.hasAssinatura && (this.user || force)) {
        const request = await Apis.Plans.Assinatura.getAssinatura(true)
        const success = Factories.Apis.success(request)

        if (success) {
          AssinaturasStore.commit('ASSINATURA', request.data.value)
          if (this.hasAssinatura) {
            const assinaturaCalculadora:
              Boolean = AssinaturasStore.getters.ASSINATURA_PLANO_CALCULADORA

            if (assinaturaCalculadora) {
              await this.setNavBarRoles(true)
            }

            resolve()
          }
        } else { resolve() }
      } else {
        resolve()
      }
    })
  }

  @Watch('$route')
  async onRouteChanged(to, from) {
    await this.changeRoute(to, from)
  }

  disableConsole() {
    const consoleFallback = () => {}
    (window as any).console = {
      assert: consoleFallback,
      clear: consoleFallback,
      count: consoleFallback,
      countReset: consoleFallback,
      debug: consoleFallback,
      dir: consoleFallback,
      dirxml: consoleFallback,
      error: consoleFallback,
      group: consoleFallback,
      groupCollapsed: consoleFallback,
      groupEnd: consoleFallback,
      info: consoleFallback,
      log: consoleFallback,
      table: consoleFallback,
      time: consoleFallback,
      timeEnd: consoleFallback,
      timeLog: consoleFallback,
      timeStamp: consoleFallback,
      trace: consoleFallback,
      warn: consoleFallback,
    }
  }
}
